import { useEffect, useRef, useState } from 'react';
import { useLocation } from 'react-router-dom';

const CURRENT_VERSION = process.env.REACT_APP_BUILD_VERSION || null;

export default function VersionManager() {
  const [hasUpdate, setHasUpdate] = useState(false);
  const [updateDetectedAt, setUpdateDetectedAt] = useState(null);
  const location = useLocation();
  const checking = useRef(false);
  const reloaded = useRef(false);

  useEffect(() => {
    if (!CURRENT_VERSION) return;

    const check = async () => {
      if (checking.current || reloaded.current) return;
      checking.current = true;
      try {
        const res = await fetch('/version.json', { cache: 'no-store' });
        const data = await res.json();
        if (data.version && data.version !== CURRENT_VERSION) {
          setHasUpdate(true);
          setUpdateDetectedAt(location.pathname);
        }
      } catch {
        // ignore errors
      } finally {
        checking.current = false;
      }
    };

    check();
    const id = setInterval(check, 5 * 60 * 1000);
    return () => clearInterval(id);
  }, []);

  // Helper: reload once per tab per version
  const triggerReloadOnce = () => {
    if (!CURRENT_VERSION) return;
    if (reloaded.current) return;

    const key = `rb_reloaded_for_${CURRENT_VERSION}`;
    if (sessionStorage.getItem(key)) {
      reloaded.current = true;
      return;
    }

    reloaded.current = true;
    sessionStorage.setItem(key, '1');
    window.location.reload();
  };

  // Only reload on route change after update is detected
  useEffect(() => {
    if (!CURRENT_VERSION) return;
    if (!hasUpdate) return;
    if (!updateDetectedAt) return;
    if (location.pathname !== updateDetectedAt) {
      triggerReloadOnce();
    }
  }, [location, hasUpdate, updateDetectedAt]);

  return null;
}
